import React, { Suspense, lazy } from 'react';
import { useContext, useState } from 'react';
import { 
  //BrowserRouter as Router, 
  Routes,
  Route, 
  useLocation,
} from 'react-router-dom';

import Header from './components/Header';
import SideBar from './components/Sidebar';
import TaskYearsCyclesStructure from './components/TaskList';
import FormList from './components/FormList';
import AssetList from './components/AssetList';
//import Task from './components/Task';
import { FormPage, FormPageAppProvider } from '@lk/form-renderer';
import Loader from './components/common/Loader';
import ConfirmationModal from './components/common/ConfirmationModal';
import FormBuilder from './components/FormBuilder/FormBuilder';
import FormCreate from './components/FormCreate';
import TasksLoad from './components/TasksLoad';
import TaskCreate from './components/TaskCreate';
import AssetCreateEdit from './components/AssetCreateEdit';
import AssetMassLoad from './components/AssetMassLoad';
import UserNotifications from './components/UserNotifications';
import TaskHistory from './components/TaskHistory';
import TicketList from './components/TicketList';
import TicketCreate from './components/TicketCreate';
import TicketUpdate from './components/Ticket_Update';
import LabBroadcast from './components/LabBroadcast';

//import ExportGrid from './components/ExportDataGrid';

//import axios from 'axios';
import axios_api from './Api';
import { API_URL, AUTH_TOKEN } from './Context';
import FormEditParams from './components/FormEditParams';


function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    // "document.documentElement.scrollTo" is the magic for React Router Dom v6
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // Optional if you want to skip the scrolling animation
    });
  }, [pathname]);

  return null;
}


// JS code splitting
const DataGrid = lazy(() => import('./components/ExportDataGrid'));
const ExportMultipleTasks = lazy(() => import('./components/ExportMultipleTasks'));


function getUnreadNotificationsCount(notifications) {
  if (!Array.isArray(notifications)) {
    return 0;
  }

  return notifications.filter(notification => notification?.viewed === false).length;
}


function ProtectedPages({setAuthToken, appUserName, setAppUserName}) {
  const [userNotifications, setUserNotifications] = useState([]);
  const [notificationsLoading, setNotificationsLoading] = useState(true);
  const [unreadNotificationsCount, setUnreadNotificationsCount] = useState(0);
  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);

  React.useEffect(() => {
    let userNotifications = axios_api.get(api_url + '/specialist_notifications/', {
      headers: {"Authorization": token},        
    });
    
    userNotifications.then(
      (result) => {
        let apiReturnedNotifications = result.data
        setUserNotifications(apiReturnedNotifications);
        setUnreadNotificationsCount(getUnreadNotificationsCount(apiReturnedNotifications));
        setNotificationsLoading(false);
      },
      (error) => {
        console.log(error);
        setUserNotifications([]);
        setUnreadNotificationsCount(0);
        setNotificationsLoading(false);
      }
    );
  }, [])

  function MarkNotificationsRead(notifications) {
    const notificationsList = Array.isArray(notifications) ? notifications : [];
    const unreadIds = notificationsList
      .filter(notification => notification?.viewed === false)
      .map(notification => notification.id)
      .filter(id => Number.isInteger(id));

    if (!unreadIds.length) {
      return;
    }

    axios_api.put(api_url + '/specialist_notifications/', {
      operation: 'mark-read',
      ids: unreadIds
    }, {
      headers: {"Authorization": token}
    })
    .then(() => {
      setUnreadNotificationsCount(0);
    })
    .catch((error) => {
      console.log(error);
    });
  }

  
  return(
    <FormPageAppProvider
      apiClient={axios_api}
      apiUrlContext={API_URL}
      authTokenContext={AUTH_TOKEN}
      Loader={Loader}
      ConfirmationModal={ConfirmationModal}
    >
    <>
      <ScrollToTop />
      <Header 
        setAuthToken={setAuthToken} 
        appUserName={appUserName} 
        setAppUserName={setAppUserName}
        notificationsCount={unreadNotificationsCount}
      /> 
      <div className="row plato">
        <div className="col-2 fixed-top vh-100 p-0 left-panel-wrapper">
          <SideBar
          />
        </div>
        <div className="col-2"></div>
        <div className="col-10 border-start px-4 pb-4 right-panel">
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route exact path="/" element={
                <TaskYearsCyclesStructure/>
              }/>
              <Route exact path="/form_list" element={
                <FormList/>
              }/>
              <Route exact path="/asset_list" element={
                <AssetList/>
              }/>
              <Route exact path="/asset_create" element={
                <AssetCreateEdit/>
              }/>
              <Route exact path="/asset_mass_load" element={
                <AssetMassLoad/>
              }/>
              <Route path="/asset/:assetId" element={
                <AssetCreateEdit/>
              }/>              
              <Route exact path="/form_create" element={
                <FormCreate/>
              }/>
              <Route exact path="/load_tasks" element={
                <TasksLoad/>
              }/>
              <Route path="/notifications" element={
                <UserNotifications
                  notifications={userNotifications}
                  onOpen={MarkNotificationsRead}
                  loading={notificationsLoading}
                />
              }/>
              <Route exact path="/task_create" element={
                <TaskCreate/>
              }/>                          
              <Route path="/form_builder/:formId" element={
                <FormBuilder/>
              }/>              
              <Route path="/task/:taskId" element={
                <FormPage
                  formMode="specialist"
                  taskUrl="/manage_task/"
                />
              }/>
              <Route path="/task/:taskId/history" element={
                <TaskHistory />
              }/>
              <Route path="/export/:taskId" element={
                <DataGrid/>
              }/>
              <Route exact path="/export_multiple_tasks" element={
                <ExportMultipleTasks/>
              }/>
              <Route exact path="/tickets" element={
                <TicketList/>
              }/>
              <Route exact path="/ticket/create" element={
                <TicketCreate/>
              }/>
              <Route exact path="/broadcast" element={
                <LabBroadcast/>
              }/>
              <Route path="/ticket/:ticketId" element={
                <TicketUpdate/>
              }/>
            </Routes>
          </Suspense>  
        </div>
      </div>
    </>
    </FormPageAppProvider>
  )
}

export default ProtectedPages